import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "onClick"]

import { EMIT } from '@/enum';
import { MenuItem } from 'primevue/menuitem';
import TabMenu, { TabMenuChangeEvent } from 'primevue/tabmenu';
import { ref, watch, onUnmounted, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';

interface TabMenuProps {
  items: MenuItem[];
  activeIndex?: number;
  className?: string;
  attendeeFilter?: number;
  activeRoute?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTabMenu',
  props: {
    items: { default: () => {
    return [{}] as MenuItem[];
  } },
    activeIndex: { default: 0 },
    className: { default: 'tab-menu-container' },
    attendeeFilter: { default: 0 },
    activeRoute: { default: undefined }
  },
  setup(__props: any, { emit: __emit }) {

const route = useRoute();

const tabMenuProps = __props;

const emit = __emit;

const itemsAreRoutes = computed<boolean>(() => tabMenuProps.items.every((item) => item?.route));

const activeTabIndex = computed(() => {
  if (tabMenuProps.activeRoute) {
    return tabMenuProps.items.findIndex((item) => item.route === tabMenuProps.activeRoute);
  }
  if (itemsAreRoutes.value) {
    return tabMenuProps.items.findIndex((item) => item.route === route.path);
  }
  return tabMenuProps.activeIndex;
});

const aiRef = ref(activeTabIndex.value);

watch(activeTabIndex, (newValue) => {
  aiRef.value = newValue >= 0 ? newValue : 0;
});

onMounted(() => {
  window.addEventListener('popstate', setFocusOnTabItem);
  aiRef.value = activeTabIndex.value;
});

onUnmounted(() => {
  window.removeEventListener('popstate', setFocusOnTabItem);
});

const setFocusOnTabItem = () => {
  const parent = document.getElementsByClassName('p-tabmenuitem p-highlight')[0];
  if (parent) {
    const target = parent.getElementsByClassName('p-menuitem-link')[0];
    if (target) (target as HTMLElement).focus();
  }
};

const tabChange = (e: TabMenuChangeEvent) => {
  setFocusOnTabItem();
  emit(EMIT.TAB, e.index);
};

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!__props.items || !__props.items.length)
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          height: "36px",
          width: "530px",
          "border-radius": "6"
        }))
      : _createCommentVNode("", true),
    (__props.items.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(__props.className)
        }, [
          (itemsAreRoutes.value)
            ? (_openBlock(), _createBlock(_unref(TabMenu), {
                key: 0,
                "active-index": aiRef.value,
                "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((aiRef).value = $event)),
                model: __props.items,
                onTabChange: tabChange
              }, {
                item: _withCtx(({ item, props }) => [
                  (item.route)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: item.route,
                        custom: ""
                      }, {
                        default: _withCtx(({ href, navigate }) => [
                          _createElementVNode("a", _mergeProps({ href: href }, props.action, { onClick: navigate }), [
                            _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.label)), _toDisplayString(item.label), 17)
                          ], 16, _hoisted_1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["active-index", "model"]))
            : (_openBlock(), _createBlock(_unref(TabMenu), {
                key: 1,
                "active-index": aiRef.value,
                "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => ((aiRef).value = $event)),
                model: __props.items,
                onTabChange: tabChange
              }, null, 8, ["active-index", "model"])),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tab-menu-details" }, null, -1))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})